import { Radio, RadioGroup } from '@headlessui/react';
import { cx } from './cx';

export interface SegmentedOption<T extends string> {
  value: T;
  label: string;
}

export interface SegmentedControlProps<T extends string> {
  /** Names the group for screen readers, e.g. "Household". */
  label: string;
  options: SegmentedOption<T>[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
}

/** A row of mutually exclusive options; use it for two to four short choices instead of a select. */
export function SegmentedControl<T extends string>({ label, options, value, onChange, className }: SegmentedControlProps<T>) {
  return (
    <RadioGroup
      value={value}
      onChange={onChange}
      aria-label={label}
      className={cx('inline-flex gap-0.5 rounded-lg bg-gray-100 p-0.5 dark:bg-gray-800', className)}
    >
      {options.map((o) => (
        <Radio
          key={o.value}
          value={o.value}
          className={cx(
            'cursor-pointer whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium text-gray-600 transition-colors dark:text-gray-400',
            'hover:text-gray-900 data-[checked]:bg-white data-[checked]:text-gray-900 data-[checked]:shadow-sm',
            'dark:hover:text-gray-100 dark:data-[checked]:bg-gray-600 dark:data-[checked]:text-white dark:data-[checked]:shadow-none',
            'focus:outline-none data-[focus]:ring-2 data-[focus]:ring-indigo-500',
          )}
        >
          {o.label}
        </Radio>
      ))}
    </RadioGroup>
  );
}
